import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export function SkeletonCard() {
  return (
    <div 
      className="surface radii-md shadow-soft" 
      style={{ 
        padding: 24, 
        height: "100%",
        border: "1px solid rgba(20, 184, 166, 0.2)",
        background: "rgba(30, 41, 59, 0.6)"
      }}
    >
      <div style={{ 
        height: 20, 
        width: "70%", 
        background: "linear-gradient(90deg, rgba(20, 184, 166, 0.2) 0%, rgba(20, 184, 166, 0.1) 50%, rgba(20, 184, 166, 0.2) 100%)",
        backgroundSize: "200% 100%",
        borderRadius: 4,
        marginBottom: 16,
        animation: "skeleton-loading 1.5s ease-in-out infinite"
      }} />
      <div style={{ 
        height: 16, 
        width: "100%", 
        background: "linear-gradient(90deg, rgba(20, 184, 166, 0.15) 0%, rgba(20, 184, 166, 0.08) 50%, rgba(20, 184, 166, 0.15) 100%)",
        backgroundSize: "200% 100%",
        borderRadius: 4,
        marginBottom: 12,
        animation: "skeleton-loading 1.5s ease-in-out infinite"
      }} />
      <div style={{ 
        height: 16, 
        width: "85%", 
        background: "linear-gradient(90deg, rgba(20, 184, 166, 0.15) 0%, rgba(20, 184, 166, 0.08) 50%, rgba(20, 184, 166, 0.15) 100%)",
        backgroundSize: "200% 100%",
        borderRadius: 4,
        marginBottom: 16,
        animation: "skeleton-loading 1.5s ease-in-out infinite"
      }} />
      <div style={{ 
        height: 40, 
        width: "40%", 
        background: "linear-gradient(90deg, rgba(20, 184, 166, 0.2) 0%, rgba(20, 184, 166, 0.1) 50%, rgba(20, 184, 166, 0.2) 100%)",
        backgroundSize: "200% 100%",
        borderRadius: 8,
        marginTop: "auto",
        animation: "skeleton-loading 1.5s ease-in-out infinite"
      }} />
    </div>
  );
}

export function SkeletonPage() {
  return (
    <Container fluid className="about-section" style={{ paddingTop: 120, paddingBottom: 60 }}>
      <Container>
        {/* Header skeleton */}
        <div style={{ marginBottom: 40, textAlign: "center" }}>
          <div style={{ 
            height: 16, 
            width: 120, 
            background: "linear-gradient(90deg, rgba(20, 184, 166, 0.2) 0%, rgba(20, 184, 166, 0.1) 50%, rgba(20, 184, 166, 0.2) 100%)",
            backgroundSize: "200% 100%",
            borderRadius: 4,
            margin: "0 auto 12px",
            animation: "skeleton-loading 1.5s ease-in-out infinite"
          }} />
          <div style={{ 
            height: 40, 
            width: "60%", 
            maxWidth: 500,
            background: "linear-gradient(90deg, rgba(20, 184, 166, 0.25) 0%, rgba(20, 184, 166, 0.15) 50%, rgba(20, 184, 166, 0.25) 100%)",
            backgroundSize: "200% 100%",
            borderRadius: 4,
            margin: "0 auto 16px",
            animation: "skeleton-loading 1.5s ease-in-out infinite"
          }} />
          <div style={{ 
            height: 16, 
            width: "80%", 
            maxWidth: 600,
            background: "linear-gradient(90deg, rgba(20, 184, 166, 0.15) 0%, rgba(20, 184, 166, 0.08) 50%, rgba(20, 184, 166, 0.15) 100%)",
            backgroundSize: "200% 100%",
            borderRadius: 4,
            margin: "0 auto",
            animation: "skeleton-loading 1.5s ease-in-out infinite"
          }} />
        </div>

        {/* Content skeleton */}
        <Row style={{ justifyContent: "center" }}>
          {[1, 2, 3].map((i) => (
            <Col key={i} md={6} lg={4} style={{ marginBottom: 24 }}>
              <SkeletonCard />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

// Add CSS animation for skeleton loading
const style = document.createElement('style');
style.textContent = `
  @keyframes skeleton-loading {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;
document.head.appendChild(style);

